import(/* webpackMode: "eager" */ "/opt/build/repo/assets/images/about/handCursor.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/images/about/nestedCircles.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/images/about/shield.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/calendar.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/ideaHexagon.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/target.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/assets/svg/userAccountHexagon.svg");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
